//// filepath: d:\NwN\content-creation-frontend\src\components\Common\CustomSwiper.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Pagination } from "swiper/modules";
import { styled } from "@mui/material/styles";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Styled navigation buttons
const StyledSwiperButton = styled("div")(({ theme }) => ({
  border: "1px solid #DDD",
  width: "30px !important",
  height: "30px !important",
  borderRadius: "50%",
  "--swiper-navigation-size": "20px",
  background: "rgba(255, 255, 255, 0.9)",
  color: theme.palette.primary.main,
  "&:hover": {
    color: "#5A7DBA",
  },
}));

const CustomSwiper = ({
  data = [],
  renderItem,
  spaceBetween = 5,
  slidesPerView = "auto",
  ...props
}) => {
  return (
    <Swiper
      modules={[Navigation, Mousewheel, Pagination]}
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      mousewheel={true}
      navigation={{
        nextEl: ".custom-swiper-button-next",
        prevEl: ".custom-swiper-button-prev",
      }}
      pagination={{ type: "custom" }}
      style={{ marginLeft: "0px" }}
      {...props}
    >
      {data.map((item, index) => (
        <SwiperSlide key={index} style={{ width: "fit-content" }}>
          {renderItem(item, index)}
        </SwiperSlide>
      ))}
      <StyledSwiperButton
        className="swiper-button-next custom-swiper-button-next"
        style={{ right: "5px" }}
      />
      <StyledSwiperButton
        className="swiper-button-prev custom-swiper-button-prev"
        style={{ left: "5px" }}
      />
    </Swiper>
  );
};

export default CustomSwiper;
